module.exports = __webpack_public_path__ + "static/media/pviz_logo_md.913a5ad4.png";